(function () {
  var MAX_COMPARE = 3;
  var COMPARE_URL = '/pages/compare';
  var KEYS = { wishlist: 'onaro:wishlist', compare: 'onaro:compare' };
  function read(k) { try { return JSON.parse(localStorage.getItem(KEYS[k]) || '[]'); } catch (e) { return []; } }
  function write(k, arr) {
    localStorage.setItem(KEYS[k], JSON.stringify(arr));
    document.dispatchEvent(new CustomEvent('onaro:change', { detail: { key: k, items: arr } }));
  }
  function has(k, handle) { return read(k).some(function (p) { return p.handle === handle; }); }
  function count(k) { return read(k).length; }
  function toggle(k, item) {
    var arr = read(k);
    var i = arr.findIndex(function (p) { return p.handle === item.handle; });
    if (i > -1) { arr.splice(i, 1); }
    else {
      if (k === 'compare' && arr.length >= MAX_COMPARE) {
        window.alert('You can compare up to ' + MAX_COMPARE + ' watches at once.');
        return false;
      }
      arr.push(item);
    }
    write(k, arr);
    return true;
  }
  function remove(k, handle) { write(k, read(k).filter(function (p) { return p.handle !== handle; })); }

  function injectStyles() {
    if (document.getElementById('onaro-fav-styles')) return;
    var css =
      '#onaro-compare-bar{position:fixed;left:0;right:0;bottom:0;z-index:60;transform:translateY(120%);transition:transform .35s ease;background:rgb(var(--colors-background));border-top:1px solid rgba(var(--colors-line-and-border),.6);box-shadow:0 -6px 24px rgba(0,0,0,.08);}'
      + '#onaro-compare-bar.is-visible{transform:translateY(0);}'
      + '#onaro-compare-bar .ocb-inner{max-width:var(--page-width);margin:0 auto;padding:12px 20px;display:flex;align-items:center;justify-content:space-between;gap:16px;}'
      + '#onaro-compare-bar .ocb-items{display:flex;gap:10px;flex-wrap:nowrap;overflow:hidden;}'
      + '#onaro-compare-bar .ocb-thumb{position:relative;width:56px;height:56px;background:#f3f3f1;display:block;overflow:hidden;flex:0 0 auto;}'
      + '#onaro-compare-bar .ocb-thumb img{width:100%;height:100%;object-fit:cover;}'
      + '#onaro-compare-bar .ocb-x{position:absolute;top:0;right:0;width:18px;height:18px;line-height:16px;text-align:center;background:rgba(0,0,0,.6);color:#fff;font-size:13px;cursor:pointer;}'
      + '#onaro-compare-bar .ocb-actions{display:flex;align-items:center;gap:16px;flex:0 0 auto;}'
      + '#onaro-compare-bar .ocb-clear{background:none;border:0;cursor:pointer;font-size:12px;letter-spacing:.1em;text-transform:uppercase;color:rgb(var(--colors-text));opacity:.7;font-family:var(--font-body-family);}'
      + '#onaro-compare-bar .ocb-clear:hover{opacity:1;}'
      + '#onaro-compare-bar .ocb-go{display:inline-flex;align-items:center;gap:8px;background:rgb(var(--colors-button));color:rgb(var(--colors-button-text));padding:12px 22px;font-size:12px;letter-spacing:.12em;text-transform:uppercase;text-decoration:none;font-family:var(--font-body-family);white-space:nowrap;}'
      + '#onaro-compare-bar .ocb-count{display:inline-flex;min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:rgba(255,255,255,.25);align-items:center;justify-content:center;font-size:11px;}'
      + '@media(max-width:560px){#onaro-compare-bar .ocb-thumb{width:44px;height:44px;}#onaro-compare-bar .ocb-go{padding:10px 16px;}#onaro-compare-bar .ocb-clear{display:none;}}'
      /* injected card compare/wishlist row */
      + '.oc-fav-row{display:flex;align-items:center;justify-content:space-between;gap:8px;border-top:1px solid rgba(var(--colors-line-and-border),.6);margin-top:12px;padding-top:12px;}'
      + '.oc-fav-btn{display:inline-flex;align-items:center;gap:7px;background:none;border:0;cursor:pointer;padding:0;font-family:var(--font-body-family);font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:rgb(var(--colors-text));opacity:.85;}'
      + '.oc-fav-btn:hover{opacity:1;}'
      + '.oc-fav-btn .oc-box{width:12px;height:12px;border:1px solid currentColor;display:inline-block;flex:0 0 auto;}'
      + '.oc-fav-btn svg{width:13px;height:13px;flex:0 0 auto;}'
      + '.oc-fav-btn .lbl-on,.oc-fav-btn .ic-on{display:none;}'
      + '.oc-fav-btn.is-active{opacity:1;color:rgb(var(--colors-heading));}'
      + '.oc-fav-btn.is-active .lbl-off,.oc-fav-btn.is-active .ic-off{display:none;}'
      + '.oc-fav-btn.is-active .lbl-on{display:inline;}'
      + '.oc-fav-btn.is-active .ic-on{display:inline-block;}'
      + '.oc-fav-btn.is-active .oc-box{background:currentColor;}';
    var s = document.createElement('style');
    s.id = 'onaro-fav-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function ensureBar() {
    var bar = document.getElementById('onaro-compare-bar');
    if (!bar) {
      injectStyles();
      bar = document.createElement('div');
      bar.id = 'onaro-compare-bar';
      bar.innerHTML = '<div class="ocb-inner"><div class="ocb-items"></div><div class="ocb-actions"><button type="button" class="ocb-clear">Clear</button><a class="ocb-go" href="' + COMPARE_URL + '">Compare <span class="ocb-count">0</span></a></div></div>';
      document.body.appendChild(bar);
      bar.querySelector('.ocb-clear').addEventListener('click', function () { write('compare', []); sync(); });
      bar.addEventListener('click', function (e) {
        var x = e.target.closest('.ocb-x');
        if (x) { e.preventDefault(); e.stopPropagation(); remove('compare', x.getAttribute('data-remove')); sync(); }
      });
    }
    return bar;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function renderBar() {
    var items = read('compare');
    var bar = ensureBar();
    if (!items.length) { bar.classList.remove('is-visible'); return; }
    bar.classList.add('is-visible');
    bar.querySelector('.ocb-count').textContent = items.length;
    bar.querySelector('.ocb-items').innerHTML = items.map(function (p) {
      return '<a class="ocb-thumb" href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') + '<span class="ocb-x" data-remove="' + esc(p.handle) + '">&times;</span></a>';
    }).join('');
  }

  /* Inject a compare / wishlist row into theme product cards on collection pages */
  function injectCards() {
    if (!document.querySelector('.theme-template-collection')) return;
    injectStyles();
    var heart = '<svg class="ic-on" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 21s-7-4.35-9.5-8.5C1 9 3 5.5 6.5 5.5c2 0 3.5 1.5 5.5 3.5 2-2 3.5-3.5 5.5-3.5 3.5 0 5.5 3.5 4 7-2.5 4.15-9.5 8.5-9.5 8.5z"></path></svg>';
    var plus = '<svg class="ic-off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
    document.querySelectorAll('.theme-template-collection .card-product').forEach(function (card) {
      if (card.querySelector('.oc-fav-row')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var url = link.getAttribute('href') || '';
      var handle = url.split('/products/')[1] ? url.split('/products/')[1].split('?')[0].split('#')[0] : '';
      if (!handle) return;
      var titleEl = card.querySelector('.x-card-title');
      var vendorEl = card.querySelector('[class*="vendor"]');
      var priceEl = card.querySelector('.x-card-price');
      var imgEl = card.querySelector('img');
      var data = {
        handle: handle,
        url: url,
        title: titleEl ? titleEl.textContent.trim() : (link.getAttribute('aria-label') || ''),
        vendor: vendorEl ? vendorEl.textContent.trim() : '',
        price: (function () { if (!priceEl) return ''; var t = priceEl.textContent.replace(/\s+/g, ' ').trim(); var m = t.match(/[$£€]\s?[0-9][0-9.,]*/); return m ? m[0] : t; })(),
        image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : ''
      };
      function attrs(k) {
        return 'data-fav="' + k + '" data-handle="' + esc(data.handle) + '" data-title="' + esc(data.title) + '" data-vendor="' + esc(data.vendor) + '" data-price="' + esc(data.price) + '" data-image="' + esc(data.image) + '" data-url="' + esc(data.url) + '"';
      }
      var row = document.createElement('div');
      row.className = 'oc-fav-row';
      row.innerHTML =
        '<button type="button" class="oc-fav-btn" ' + attrs('compare') + '><span class="oc-box"></span><span class="lbl-off">Add to compare</span><span class="lbl-on">Added</span></button>'
        + '<button type="button" class="oc-fav-btn" ' + attrs('wishlist') + '>' + plus + heart + '<span class="lbl-off">Wishlist</span><span class="lbl-on">Saved</span></button>';
      var info = card.querySelector('.card-info') || card;
      info.appendChild(row);
    });
    sync();
  }

  function sync() {
    document.querySelectorAll('[data-fav]').forEach(function (btn) {
      btn.classList.toggle('is-active', has(btn.getAttribute('data-fav'), btn.getAttribute('data-handle')));
    });
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = count(el.getAttribute('data-fav-count'));
    });
    renderBar();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-fav'), {
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      vendor: btn.getAttribute('data-vendor'),
      price: btn.getAttribute('data-price'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url')
    });
    sync();
  });
  document.addEventListener('onaro:change', sync);

  window.OnaroFav = { read: read, write: write, has: has, count: count, toggle: toggle, remove: remove, sync: sync, injectCards: injectCards, KEYS: KEYS, MAX_COMPARE: MAX_COMPARE };

  function boot() {
    injectCards();
    sync();
    // re-inject for infinite-scroll / dynamically loaded cards
    var grid = document.querySelector('.theme-template-collection');
    if (grid && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(injectCards, 200); }).observe(grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
